import { render, staticRenderFns } from "./AccountGroupEdit.vue?vue&type=template&id=380dc48b"
import script from "./AccountGroupEdit.vue?vue&type=script&lang=js"
export * from "./AccountGroupEdit.vue?vue&type=script&lang=js"
import style0 from "./AccountGroupEdit.vue?vue&type=style&index=0&id=380dc48b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports